module.exports = __webpack_public_path__ + "static/media/gas-app-logo-blue.9e78c8a5.png";